import { Typography } from 'components/Typography'
import { Fragment } from 'react'
import { useTheme } from '@emotion/react'
import { numberFormatCurrency, DTI_RATIO_ASSESSMENT_MAP } from '../tools'
import HourGlass from 'components/Svgs/HourGlass'

const generateDebtSummary = (beginningLine, totalDebt, moreEachMonth) => {
  return [
    <Fragment key="totalDebt">
      {beginningLine} <span>{numberFormatCurrency(moreEachMonth)} more each month</span>
    </Fragment>,
    ' and',
    <Fragment key="moreTotalDebt">
      <span> {numberFormatCurrency(totalDebt)} more</span>
    </Fragment>,
    ' in total debt',
  ]
}

export const DtiWait = ({
  dtiRatioAssessment = DTI_RATIO_ASSESSMENT_MAP.low,
  beginningLine = 'If you wait 3 more months to get rid of debt, you’re estimated to pay',
  totalDebt = 2300,
  moreEachMonth = 57,
}) => {
  const debtSummary = generateDebtSummary(beginningLine, totalDebt, moreEachMonth)
  const theme = useTheme()
  const ratingMap = {
    [DTI_RATIO_ASSESSMENT_MAP.maximum]: {
      fontColor: theme.ascend.colors.content.negative,
      backgroundColor: theme.ascend.colors.red[50],
      titleText: 'Act now to save cash!',
    },
    [DTI_RATIO_ASSESSMENT_MAP.high]: {
      fontColor: theme.ascend.colors.content.negative,
      backgroundColor: theme.ascend.colors.red[50],
      titleText: 'Act now to save cash!',
    },
    [DTI_RATIO_ASSESSMENT_MAP.medium]: {
      fontColor: theme.ascend.colors.content.warning,
      backgroundColor: theme.ascend.colors.yellow[50],
      titleText: 'Act now to save cash!',
    },
    [DTI_RATIO_ASSESSMENT_MAP.low]: {
      fontColor: theme.ascend.colors.content.positive,
      backgroundColor: theme.ascend.colors.green[50],
      titleText: 'Act now to save cash!',
    },
  }

  const title = ratingMap[dtiRatioAssessment].titleText
  const fontColor = ratingMap[dtiRatioAssessment].fontColor
  const backgroundColor = ratingMap[dtiRatioAssessment].backgroundColor

  return (
    <div
      className="rounded flex flex-col p-4 gap-2 max-w-[430px] mb-4"
      style={{ backgroundColor: backgroundColor }}
    >
      <div className="flex items-center mb-2 title-container">
        <HourGlass className="mr-2" style={{ fontColor }} />
        <Typography
          className="font-bold"
          style={{ fontColor }}
          variant="labelSm"
          data-testid="dti-wait-title"
        >
          {title}
          <sup>1</sup>
        </Typography>
      </div>

      <Typography
        className="text-[#5C708A] debt-text font-bold"
        variant="bodySm"
        data-testid="dti-wait-paragraph"
      >
        {debtSummary}
      </Typography>
    </div>
  )
}
